import React from "react"
import { Link } from "react-router-dom"
import { Badge } from "reactstrap"

export const columns = myUser => [
  {
    text: "Request #",
    dataField: "requestNumber",
    sort: true,
    formatter: (cellContent, cpsRequest) => (
      <div>
        <Link
          to={`/cps-requests/${cpsRequest.id}`}
          className="text-body fw-bold"
        >
          {cellContent}
        </Link>
        {cpsRequest.parentRequestNumber && (
          <div className="text-muted small">
            <i className="bx bx-link me-1"></i>
            Parent: {cpsRequest.parentRequestNumber}
          </div>
        )}
        {cpsRequest.isParentRequest && cpsRequest.subRequests?.length > 0 && (
          <div className="text-info small">
            <i className="bx bx-subdirectory-right me-1"></i>
            {cpsRequest.subRequests.length} sub-request(s)
          </div>
        )}
      </div>
    ),
  },
  {
    text: "Type",
    dataField: "type",
    sort: true,
    formatter: (cellContent, cpsRequest) => (
      <div>
        <Badge
          className={`font-size-12 badge-soft-${
            cellContent === "Programming" ? "primary" : "info"
          }`}
        >
          {cellContent}
        </Badge>
        {cpsRequest.softwareVersion && (
          <div className="mt-1">
            <Badge color="outline-primary" className="font-size-10">
              {cpsRequest.softwareVersion}
            </Badge>
          </div>
        )}
      </div>
    ),
  },
  {
    text: "Article Description",
    dataField: "articleDescription",
    sort: true,
  },
  {
    text: "Customer",
    dataField: "requestorCompanyName",
    sort: true,
    formatter: cellContent => cellContent || "-",
  },
  {
    text: "Quantity",
    dataField: "quantity",
    sort: true,
    formatter: (cellContent, cpsRequest) => {
      const quantityType =
        cpsRequest.quantityType === "onetime" ? "One-time" : "Annual"
      return `${cellContent?.toLocaleString()} pcs (${quantityType})`
    },
  },
  {
    text: "Status",
    dataField: "status",
    sort: true,
    formatter: cellContent => {
      let badgeColor = "secondary"

      switch (cellContent) {
        case "Request Created":
          badgeColor = "primary"
          break
        case "CPS Offer":
          badgeColor = "warning"
          break
        case "Customer Decision":
          badgeColor = "info"
          break
        case "Goods Shipped":
        case "Goods Received":
          badgeColor = "secondary"
          break
        case "Sample Production":
        case "Sample Approval":
          badgeColor = "info"
          break
        case "Production":
          badgeColor = "warning"
          break
        case "Stock Management":
          badgeColor = "success"
          break
        case "Completed":
          badgeColor = "success"
          break
        case "Cancelled":
          badgeColor = "danger"
          break
        default:
          badgeColor = "secondary"
      }

      return (
        <Badge className={`font-size-12 badge-soft-${badgeColor}`}>
          {cellContent}
        </Badge>
      )
    },
  },
  {
    text: "Created",
    dataField: "dateCreated",
    sort: true,
    formatter: cellContent => {
      if (!cellContent) return "-"
      return new Date(cellContent).toLocaleDateString("de-DE")
    },
  },
  {
    text: "Updated",
    dataField: "dateUpdated",
    sort: true,
    formatter: cellContent => {
      if (!cellContent) return "-"
      return new Date(cellContent).toLocaleDateString("de-DE")
    },
  },
  {
    text: "Action",
    dataField: "action",
    isDummyField: true,
    editable: false,
    formatter: (cellContent, cpsRequest) => (
      <div className="d-flex gap-3">
        <Link to={`/cps-requests/${cpsRequest.id}`} className="text-success">
          <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
        </Link>
      </div>
    ),
  },
]
